import { BareFetcher, SWRConfiguration } from 'swr'
import axios from 'axios'

const swrFetcher: BareFetcher<any> = async (resource: any) => {
  const { data } = await axios.get(resource)
  return data
}

export const swrConfig: SWRConfiguration = {
  refreshInterval: 60000,
  fetcher: swrFetcher,
}
